import axios, { AxiosResponse } from "axios";
import config from "../authentication/config";
import {
  DASHBOARD_COMMIT_CHUNKS_API,
  DASHBOARD_DOWNLOAD_RECORDS_API,
  DM_CANCEL_UPLOAD_API,
  UPLOAD_CHUNK_API,
} from "../apiEndPoint/apiEndPoint";

export const cancelUploadAPiCall = async (siteId: string) => {
  try {
    const apiConfig = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        siteId,
      },
    };
    const k = await axios.get(DM_CANCEL_UPLOAD_API, apiConfig);
  } catch (err) {}
};

export const commitChunkApiAxios = async (
  fileNameUpload: string,
  fileSize: number,
  rowKey: React.MutableRefObject<string>,
  siteId: string
) => {
  var obj = {
    filename: fileNameUpload,
    fileuploadtype: "largefileupload",
    filesize: fileSize,
    rowKey: rowKey.current,
  };
  const apiConfig = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      siteId,
    },
  };
  await axios
    .post(DASHBOARD_COMMIT_CHUNKS_API, obj, apiConfig)
    .then((response) => {
      // Handle the response
      return response;
    });
};

export const chunkAPIAxios = async (
  chunk: Blob,
  blockNumber: number,
  fileNameUpload: string,
  fileSize: number,
  finallist: any[],
  rowKey: React.MutableRefObject<string>,
  fileHash: string,
  siteId: string
) => {
  let data = new FormData();
  data.append("FormFile", chunk);
  data.append("FileName", fileNameUpload);
  data.append("FileSize", fileSize.toString());
  data.append("Path", finallist.join("/"));
  data.append("FileUploadType", "largefileupload");
  data.append("BlockNumber", blockNumber.toString());
  data.append("RowKey", rowKey.current);
  data.append("IsReplace", "false");
  data.append("FileHash", fileHash);

  const apiConfig = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      siteId,
    },
  };
  // try {
  await axios.post(UPLOAD_CHUNK_API, data, apiConfig).then((response) => {
    // Handle the response
    rowKey.current = response.data.rowKey;
    return response;
  });
  // }
  // catch (error: any) {
  //     return error.response;
  // }
};
